import React, { useState, useRef } from 'react';
import './sub1.css';
import { Helmet } from 'react-helmet';
import ederlycare from '../../images/ederly care.jpeg'
import emailjs from "@emailjs/browser";
import contactConfig from '../../confi';
export default function ElderlyCare() {
  const [formData, setFormData] = useState({
    patientName: '',
    familyMemberName: '',
    email: '',
    phone: '',
    patientAge: '',
    condition: '',
    serviceType: '',
    serviceDate: '',
    address: '',
    specialRequirements: ''
  });
  const form = useRef();
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Elderly care service request submitted successfully! We will contact you soon.');
    // Reset form
    setFormData({
      patientName: '',
      familyMemberName: '',
      email: '',
      phone: '',
      patientAge: '',
      condition: '',
      serviceType: '',
      serviceDate: '',
      address: '',
      specialRequirements: ''
    });
  };

  const serviceFeatures = [
    {
      icon: "🛁",
      text: "Daily activities (bathing, dressing, grooming, feeding)"
    },
    {
      icon: "🚶",
      text: "Mobility and movement support"
    },
    {
      icon: "💊",
      text: "Medicine reminders and basic health checks"
    },
    {
      icon: "💖",
      text: "Companionship and emotional support"
    },
    {
      icon: "🍽️",
      text: "Assistance with meals, walking, and light household help"
    },
    {
      icon: "🏥",
      text: "Post-surgery or rehabilitation support"
    }
  ];

  const whyChooseUs = [
    {
      title: "Verified & Trained Caregivers",
      description: "Each caregiver is background-checked, medically trained, and experienced in elderly care.",
      icon: "✅"
    },
    {
      title: "Compassionate & Respectful",
      description: "We treat every senior with patience, dignity, and affection — like family.",
      icon: "💖"
    },
    {
      title: "Flexible Care Plans",
      description: "Choose from hourly, day, night, or live-in caregivers to suit your needs.",
      icon: "⏰"
    },
    {
      title: "Regular Monitoring",
      description: "Our team stays in touch to ensure your loved one's well-being and comfort.",
      icon: "📊"
    }
  ];

  const processSteps = [
    {
      step: "1",
      title: "Tell Us Your Requirement",
      description: "Share details about your loved one's health, age, and care needs"
    },
    {
      step: "2",
      title: "Get Matched with Right Caregiver",
      description: "We shortlist verified, trained caregivers suitable for your family's needs"
    },
    {
      step: "3",
      title: "Meet & Select",
      description: "Interview the caregiver and choose the one that best fits your expectations"
    },
    {
      step: "4",
      title: "Start Service",
      description: "Your chosen caregiver begins care as per your preferred schedule"
    },
    {
      step: "5",
      title: "Ongoing Support & Supervision",
      description: "We ensure continuous service quality with regular feedback and monitoring"
    }
  ];

  const testimonials = [
    {
      name: "Mrs. Priya Patel",
      location: "Vastrapur, Ahmedabad",
      rating: "⭐⭐⭐⭐⭐",
      text: "The caregiver provided by JP Home Services takes care of my father like her own family. She's kind, responsible, and very patient."
    },
    {
      name: "Mr. Nirav Shah",
      location: "Surat",
      rating: "⭐⭐⭐⭐⭐",
      text: "We hired a full-time caregiver for my elderly mother. She now feels secure and happy at home. Excellent and reliable service!"
    },
    {
      name: "Mrs. Hemlata Joshi",
      location: "Vadodara",
      rating: "⭐⭐⭐⭐⭐",
      text: "Their staff is professional yet affectionate. It's rare to find such trustworthy care services these days."
    }
  ];

  const benefits = [
    "Verified and medically trained caregivers",
    "Polite, patient, and compassionate staff",
    "Flexible hourly, daily, or full-time care options",
    "Regular service supervision",
    "Affordable and transparent pricing",
    "24x7 customer support",
    "Available in Ahmedabad, Surat, Vadodara, Rajkot, Gandhinagar, and other major cities of Gujarat"
  ];

  const cities = [
    "Ahmedabad", "Surat", "Vadodara", "Rajkot", "Gandhinagar", "Anand", "Bhavnagar", "Jamnagar"
  ];

  const carePackages = [
    {
      name: "Basic Care Package",
      price: "₹8,999",
      period: "/month",
      features: [
        "✓ 4 hours daily care",
        "✓ Basic hygiene assistance",
        "✓ Medicine reminders",
        "✓ Meal assistance",
        "✓ Light companionship",
        "✗ Night care",
        "✗ Medical procedures"
      ],
      popular: false
    },
    {
      name: "Standard Care Package",
      price: "₹14,999",
      period: "/month",
      features: [
        "✓ 8 hours daily care",
        "✓ Complete personal care",
        "✓ Medicine management",
        "✓ Meal preparation",
        "✓ Regular companionship",
        "✓ Basic health monitoring",
        "✗ 24x7 care"
      ],
      popular: true
    },
    {
      name: "Premium Care Package",
      price: "₹24,999",
      period: "/month",
      features: [
        "✓ 12 hours daily care",
        "✓ Full personal care",
        "✓ Medical assistance",
        "✓ Special diet meals",
        "✓ Active companionship",
        "✓ Health monitoring",
        "✓ Emergency support"
      ],
      popular: false
    },
    {
      name: "24x7 Live-in Care",
      price: "₹34,999",
      period: "/month",
      features: [
        "✓ Round-the-clock care",
        "✓ Complete medical support",
        "✓ Special needs care",
        "✓ Post-surgery care",
        "✓ Daily activity planning",
        "✓ Regular health reports",
        "✓ Emergency response"
      ],
      popular: false
    }
  ];
  const handleCall = () => {
    window.open(`tel:${contactConfig.phone}`);
  };

  const handleWhatsApp = () => {
    const phoneNumber = `${contactConfig.phone}`;
    const message = 'Hello, I would like to know more about your services.';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };
  const sendEmail = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await emailjs.sendForm(
        "service_v4bj4cq", // 🔹 Replace with your EmailJS Service ID
        "template_a7bino9", // 🔹 Replace with your Template ID
        form.current,
        "EPURM9NpZ87StWlSC" // 🔹 Replace with your Public Key
      );

      alert("✅ Message sent successfully!");
      e.target.reset();
    } catch (error) {
      console.error("FAILED...", error.text);
      alert("❌ Failed to send message. Please try again later.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="main-content-wrapper">
      <Helmet>
        <title>Get Senior Citizen Care Taker in Ahmedabad - JP Home Services</title>
        <meta
          name="description"
          content=" JP Home Services offers trained senior citizen care taker in Ahmedabad - safe, respectful elderly care. 100% verified & guaranteed. Call +91 9328843812!"
        />
        <meta
          name="keywords"
          content="Elderly Care Services Ahmedabad, Senior Citizen Care Ahmedabad, Old Age Home Care Gujarat, Caregiver for Elders Ahmedabad, Full-time Elder Care, Elder Care Agency Gujarat, Home Attendant for Parents"
        />
        <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
        <link rel="canonical" href="https://jphomeservice.in/elder-care-services-in-ahmedabad" />

        {/* Open Graph */}
        <meta property="og:title" content="  Get Senior Citizen Care Taker in Ahmedabad - JP Home Services" />
        <meta property="og:description" content="JP Home Services offers trained senior citizen care taker in Ahmedabad - safe, respectful elderly care. 100% verified & guaranteed. Call +91 9328843812!" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://jphomeservice.in/elder-care-services-in-ahmedabad" />
        <meta property="og:image" content="https://jphomeservice.in/static/media/Patientcare1.b6deaca6fd8b6ef73a08.png" />
        <meta property="og:site_name" content="JP Home Services" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@" />
        <meta name="twitter:title" content=" Get Senior Citizen Care Taker in Ahmedabad - JP Home Services" />
        <meta name="twitter:description" content="JP Home Services offers trained senior citizen care taker in Ahmedabad - safe, respectful elderly care. 100% verified & guaranteed. Call +91 9328843812!" />
        <meta name="twitter:image" content="https://jphomeservice.in/static/media/Patientcare1.b6deaca6fd8b6ef73a08.png" />

        {/* JSON-LD */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "WebPage",
              "@id": "https://jphomeservice.in/elder-care-services-in-ahmedabad#webpage",
              "url": "https://jphomeservice.in/elder-care-services-in-ahmedabad",
              "name": "Senior Citizen Care Taker in Ahmedabad - JP Home Services",
              "description": "JP Home Services provides trained senior citizen care taker in Ahmedabad offering safe, respectful elderly care at home with respectful support. Hire now!",
              "inLanguage": "en-IN",
              "isPartOf": {
                "@type": "WebSite",
                "@id": "https://jphomeservice.in/#website",
                "name": "JP Home Services",
                "url": "https://jphomeservice.in/"
              },
              "publisher": {
                "@type": "Organization",
                "@id": "https://jphomeservice.in/#organization",
                "name": "JP Home Services",
                "url": "https://jphomeservice.in/"
              }
            }
          `}
        </script>
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "LocalBusiness",
              "name": "Elder Care Service in Ahmedabad",
              "image": "https://jphomeservice.in/static/media/TRANSPARNT%20LOGO.1a150556bfeacec71cee.png",
              "@id": "",
              "url": "https://jphomeservice.in/elder-care-services-in-ahmedabad",
              "telephone": "+919327365056",
              "priceRange": "₹₹",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "A-316-317, Swaminarayan Avenue,  Nr. AEC Cross Road, Naranpura",
                "addressLocality": "Ahmedabad, Gujarat",
                "postalCode": "380013",
                "addressCountry": "IN"
              },
              "geo": {
                "@type": "GeoCoordinates",
                "latitude": 23.0542109,
                "longitude": 72.5482134
              },
              "openingHoursSpecification": {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": [
                  "Monday",
                  "Tuesday",
                  "Wednesday",
                  "Thursday",
                  "Friday",
                  "Saturday",
                  "Sunday"
                ],
                "opens": "00:00",
                "closes": "23:59"
              },
              "sameAs": [
                "https://www.facebook.com/jphomeservice.in/",
                "https://www.instagram.com/jp_home_service/"
              ] 
            }
          `}
        </script>
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Elder Care Services in Ahmedabad",
            "serviceType": "Elder Care Services",
            "description": "JP Home Service provides reliable elder care services in Ahmedabad with caring and responsible support for senior citizens at home.",
            "url": "https://jphomeservice.in/elder-care-services-in-ahmedabad",
            "areaServed": {
              "@type": "City",
              "name": "Ahmedabad"
            },
            "provider": {
              "@type": "Organization",
              "name": "JP Home Service",
              "url": "https://jphomeservice.in/"
            }
          }
          `}
        </script>
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://jphomeservice.in/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Elder Care Services in Ahmedabad",
                "item": "https://jphomeservice.in/elder-care-services-in-ahmedabad"
              }
            ]
          }
          `}
        </script>
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "Review",
                "@id": "https://jphomeservice.in/elder-care-services-in-ahmedabad#review-priya",
                "itemReviewed": {
                  "@type": "Organization",
                  "name": "JP Home Service"
                },
                "author": {
                  "@type": "Person",
                  "name": "Mrs. Priya Patel"
                },
                "reviewRating": {
                  "@type": "Rating",
                  "ratingValue": 5,
                  "bestRating": 5,
                  "worstRating": 1
                },
                "reviewBody": "The caregiver provided by JP Home Services takes care of my father like her own family. She's kind, responsible, and very patient."
              },
              {
                "@type": "Review",
                "@id": "https://jphomeservice.in/elder-care-services-in-ahmedabad#review-nirav",
                "itemReviewed": {
                  "@type": "Organization",
                  "name": "JP Home Service"
                },
                "author": {
                  "@type": "Person",
                  "name": "Mr. Nirav Shah"
                },
                "reviewRating": {
                  "@type": "Rating",
                  "ratingValue": 5,
                  "bestRating": 5,
                  "worstRating": 1
                },
                "reviewBody": "We hired a full-time caregiver for my elderly mother. She now feels secure and happy at home. Excellent and reliable service!"
              },
              {
                "@type": "Review",
                "@id": "https://jphomeservice.in/elder-care-services-in-ahmedabad#review-hemlata",
                "itemReviewed": {
                  "@type": "Organization",
                  "name": "JP Home Service"
                },
                "author": {
                  "@type": "Person",
                  "name": "Mrs. Hemlata Joshi"
                },
                "reviewRating": {
                  "@type": "Rating",
                  "ratingValue": 5,
                  "bestRating": 5,
                  "worstRating": 1
                },
                "reviewBody": "Their staff is professional yet affectionate. It's rare to find such trustworthy care services these days."
              },
              {
                "@type": "AggregateRating",
                "@id": "https://jphomeservice.in/elder-care-services-in-ahmedabad#aggregate-rating",
                "itemReviewed": {
                  "@type": "Organization",
                  "name": "JP Home Service"
                },
                "ratingValue": 5,
                "bestRating": 5,
                "worstRating": 1,
                "ratingCount": 3,
                "reviewCount": 3
              }
            ]
          }
          `}
        </script>
      </Helmet>
      <div className="elderly-care-container">
        {/* Hero Section */}
        <section className="elderly-hero-section">
          <div className="container elderly-hero-container">
            <div className="elderly-hero-content">
              <h1>Elderly Care Services at Home in Ahmedabad, Surat & Across Gujarat</h1>
              <p><strong>Professional, Caring & Trustworthy Support for Your Loved Ones — Because They Deserve the Best Care at Home</strong></p>
              <p>As our parents and grandparents grow older, they deserve comfort, dignity, and companionship — not just care. At JP Home Services, we understand the emotional and physical needs of the elderly. That's why we provide professional, trained, and compassionate caregivers who ensure complete elderly care at home — blending medical support with empathy and trust.</p>
              <p>Whether you need daily assistance, post-hospital care, or full-time companionship, our caregivers make sure your loved ones are safe, comfortable, and happy right where they belong — at home.</p>
              <div className="hero-stats">
                <div className="stat-item">
                  <span className="stat-number">1000+</span>
                  <p className="stat-label">Families Served</p>
                </div>
                <div className="stat-item">
                  <span className="stat-number">100%</span>
                  <p className="stat-label">Verified Staff</p>
                </div>
                <div className="stat-item">
                  <span className="stat-number">24/7</span>
                  <p className="stat-label">Support</p>
                </div>
              </div>
            </div>
            <div className="elderly-hero-image">
              <img
                src={ederlycare}
                alt="Elderly care with compassion"
              />
            </div>
          </div>
        </section>

        {/* Floating Contact Icons */}
        <div className="floating-contact-icons">
          <div className="contact-icon whatsapp-icon" onClick={handleWhatsApp}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893c0-3.18-1.24-6.169-3.495-8.424" />
            </svg>
          </div>
          <div
            className="contact-icon call-icon"
            onClick={handleCall}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 10.999h2C22 5.869 18.127 2 12.99 2v2C17.052 4 20 6.943 20 10.999z" />
              <path d="M13 8c2.103 0 3 .897 3 3h2c0-3.225-1.775-5-5-5v2zm3.422 5.443a1.001 1.001 0 00-1.391.043l-2.393 2.461c-.576-.11-1.734-.471-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 00.043-1.391L6.859 3.513a1 1 0 00-1.391-.087l-2.17 1.861a1 1 0 00-.29.649c-.015.25-.301 6.172 4.291 10.766C11.305 20.707 16.323 21 17.705 21c.202 0 .326-.006.359-.008a.992.992 0 00.648-.291l1.86-2.171a1 1 0 00-.086-1.391l-4.064-3.696z" />
            </svg>
          </div>
        </div>

        {/* Service Features Section */}
        <section className="service-features-section">
          <div className="container">
            <div className="section-header1">
              <h2>Our Elderly Care Service Features</h2>
              <p>We provide personalized, reliable, and compassionate elderly care services designed for your family's peace of mind.</p>
            </div>

            <div className="features-grid">
              {serviceFeatures.map((feature, index) => (
                <div key={index} className="feature-item">
                  <div className="feature-icon1">{feature.icon}</div>
                  <span>{feature.text}</span>
                </div>
              ))}
            </div>

            <div className="flexibility-note">
              <p><strong>24x7 or part-time caregiving options available</strong> — We care for your parents the way you would — with patience, love, and respect.</p>
            </div>
          </div>
        </section>

        {/* Pricing Packages Section */}
        {/* <section className="pricing-packages-section">
          <div className="container">
            <div className="section-header1">
              <h2>Care Packages & Pricing</h2>
              <p>Flexible and affordable elderly care packages designed for different needs</p>
            </div>

            <div className="packages-grid">
              {carePackages.map((pkg, index) => (
                <div key={index} className={`package-card ${pkg.popular ? 'popular' : ''}`}>
                  {pkg.popular && <div className="popular-badge">Most Popular</div>}
                  <h3>{pkg.name}</h3>
                  <div className="package-price">
                    {pkg.price}<span>{pkg.period}</span>
                  </div>
                  <ul className="package-features">
                    {pkg.features.map((feature, idx) => (
                      <li key={idx} className={feature.startsWith('✗') ? 'not-included' : ''}>
                        {feature}
                      </li>
                    ))}
                  </ul>
                  <button className="package-btn">
                    Select Package
                  </button>
                </div>
              ))}
            </div>
          </div>
        </section> */}

        {/* Why Choose Us Section */}
        <section className="why-choose-section">
          <div className="container">
            <div className="section-header1">
              <h2>Why Choose JP Home Services for Elderly Care</h2>
              <p>Families across Gujarat trust JP Home Services because we bring professional reliability with human warmth. Here's why our elderly care services in Ahmedabad, Surat, and Vadodara are highly recommended:</p>
            </div>

            <div className="features-grid">
              {whyChooseUs.map((feature, index) => (
                <div key={index} className="feature-card">
                  <div className="feature-icon1">{feature.icon}</div>
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </div>
              ))}
            </div>

            <div className="additional-benefits">
              <div className="benefit-item">
                <span className="check-icon">✓</span>
                <span>Emergency Replacement & 24x7 Support - Immediate caregiver replacements and continuous service support when needed</span>
              </div>
              <div className="benefit-item">
                <span className="check-icon">✓</span>
                <span>Trusted by Premium Families Across Gujarat - Our reputation is built on safety, consistency, and genuine care</span>
              </div>
            </div>

            <div className="trust-note">
              <p><strong>At JP Home Services, we don't just care for elders — we care for your peace of mind.</strong></p>
            </div>
          </div>
        </section>

        {/* How It Works Section */}
        <section className="process-section">
          <div className="container">
            <div className="section-header1">
              <h2> How Our Elderly Care Service Works</h2>
              <p>Our process is simple, transparent, and designed for family comfort:</p>
            </div>

            <div className="process-steps">
              {processSteps.map((step, index) => (
                <div key={index} className="process-step">
                  <div className="step-number">{step.step}</div>
                  <div className="step-content">
                    <h3>{step.title}</h3>
                    <p>{step.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="process-conclusion">
              <p><strong>Caring made simple, safe, and deeply personal.</strong></p>
            </div>
          </div>
        </section>

        {/* Booking Form Section */}
        <section className="booking-section">
          <div className="container">
            <div className="booking-content">
              <div className="booking-info">
                <h2>Book Elderly Care Service</h2>
                <p>Fill out the form and we'll match you with the perfect caregiver for your loved one's needs.</p>

                <div className="service-highlights">
                  <div className="highlight-item">
                    <span className="highlight-icon">✅</span>
                    <span>Background verified and medically trained</span>
                  </div>
                  <div className="highlight-item">
                    <span className="highlight-icon">✅</span>
                    <span>Compassionate and patient caregivers</span>
                  </div>
                  <div className="highlight-item">
                    <span className="highlight-icon">✅</span>
                    <span>Flexible care plans available</span>
                  </div>
                  <div className="highlight-item">
                    <span className="highlight-icon">✅</span>
                    <span>24x7 emergency support</span>
                  </div>
                </div>

                <div className="contact-info">
                  <h3>Need Immediate Assistance?</h3>
                  <p>Call us: <strong>{contactConfig.phone}</strong></p>
                  <p>Email: <strong>{contactConfig.email}</strong></p>
                </div>
              </div>

              <div className="booking-form-container">
                <form
                  className="contact-form"
                  ref={form}
                  onSubmit={sendEmail}
                >
                  <div className="form-group123">
                    <h3>Request Elderly Care Service</h3>
                  </div>

                  {/* <div className="form-group">
                      <label htmlFor="location">Maid in Ahmedabad</label>
                    </div> */}

                  <div className="form-group">
                    <input
                      type="text"
                      id="name"
                      name="name"
                      placeholder="Your Name*"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <input
                      type="email"
                      id="email"
                      name="emailid"
                      placeholder="Email Address*"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <input
                      type="tel"
                      id="phone"
                      name="contactno"
                      placeholder="Phone Number*"
                      required
                    />
                  </div>


                  <div className="form-row">
                    <div className="form-group">
                      <select id="category" required name="ServiceRequired">
                        <option value="">Choose a category</option>
                        <option value="House Maid">House Maid</option>
                        <option value="Baby Sitting">Baby Sitting</option>
                        <option value="Elderly Care">Elderly Care</option>
                        <option value="Patient Care">Patient Care</option>
                        <option value="Cook">Cook</option>
                        <option value="Driver">Driver</option>
                        <option value="Full Time Servant">
                          24x7 Servant
                        </option>
                        <option value="Office Boy">Office Boy</option>
                        <option value="Pet Care">Pet Care</option>
                      </select>
                    </div>
                  </div>

                  {/* <div className="form-group">
                      <textarea
                        id="message"
                        placeholder="Your Message*"
                        rows="5"
                        name="user_message"
                        required
                      ></textarea>
                    </div> */}

                  <button
                    type="submit"
                    className="submit-btn1"
                    disabled={loading}
                    onClick={() => {
                      return window.gtag_report_conversion
                        ? window.gtag_report_conversion("https://jphomeservice.in/")
                        : true;
                    }}
                  >
                    {loading ? "Sending..." : "Send Message"}
                  </button>

                </form>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="testimonials-section">
          <div className="container2">
            <h2>What Families Say About Our Elderly Care</h2>
            <div className="testimonials-grid">
              {testimonials.map((testimonial, index) => (
                <div key={index} className="testimonial-card">
                  <div className="testimonial-rating">{testimonial.rating}</div>
                  <p className="testimonial-text">"{testimonial.text}"</p>
                  <div className="testimonial-author">
                    <strong>{testimonial.name}</strong>
                    <span>{testimonial.location}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>


        {/* Benefits Section */}
        <section className="benefits-section">
          <div className="container">
            <div className="section-header1">
              <h2>Benefits of Choosing JP Home Services for Elderly Care</h2>
              <p>When you choose JP Home Services, you ensure comfort, dignity, and safety for your elders — every single day.</p>
            </div>

            <div className="benefits-grid">
              {benefits.map((benefit, index) => (
                <div key={index} className="benefit-item-large">
                  <span className="check-icon">✓</span>
                  <span>{benefit}</span>
                </div>
              ))}
            </div>

            <div className="brand-tagline">
              <p><strong>Because caring for your parents shouldn't be a challenge — it should be a comfort.</strong></p>
            </div>
          </div>
        </section>

        {/* Service Coverage Section */}
        <section className="coverage-section">
          <div className="container">
            <div className="section-header">
              <h2>Service Locations</h2>
              <p>We offer professional elderly care services across Gujarat:</p>
            </div>

            <div className="cities-grid">
              {cities.map((city, index) => (
                <div key={index} className="city-item">
                  {city}
                </div>
              ))}
            </div>

            <div className="coverage-note">
              <p><strong>Our caregivers are trained to provide home care, companionship, and post-surgery support, ensuring your loved ones receive the attention and affection they deserve.</strong></p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}